import { parsePhoneNumber } from 'awesome-phonenumber';
import facepaint from 'facepaint';
import { trimStart } from 'lodash';
import moment from 'moment';
import { stringify } from 'qs';
import { breakpoints } from "../styles/theme";
import { v4 as uuidv4 } from 'uuid';
export { isMobileOnly } from 'react-device-detect';
export { css, withTheme, keyframes, Global } from '@emotion/react';
export { isMobile } from 'react-device-detect';
export { default as styled } from '@emotion/styled';
export var isUrlExternal = function (url) { return url[0] !== '/'; };
export var mq = facepaint(breakpoints.map(function (bp) { return "@media (min-width: ".concat(bp, ")"); }));
export var getAcceptHeader = function (extension) {
    switch (extension) {
        case 'pdf':
            return 'application/pdf';
        case 'jpg':
        case 'jpeg':
            return 'image/jpeg';
        case 'svg':
            return 'image/svg+xml';
        case 'png':
            return 'image/png';
        default:
            return 'application/octet-stream';
    }
};
export var uiAssets = function (path) {
    return "".concat(process.env.STORYBOOK_LOCAL_ASSETS !== 'true' ? 'https://cdn.mymoria.de/ui' : '', "/").concat(trimStart(path, '/'));
};
export var cdn = function (bucket, path, query) {
    if (path === void 0) { path = ''; }
    return "https://cdn.mymoria.de/".concat(bucket, "/").concat(trimStart(path, '/')).concat(stringify(query, {
        addQueryPrefix: true,
    }));
};
export var getDisplayName = function (WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
export var getValidPhoneFormat = function (_a) {
    var phone = _a.phone, formatType = _a.formatType, _b = _a.withSlash, withSlash = _b === void 0 ? false : _b;
    try {
        var phoneNumberInstance = parsePhoneNumber(phone, { regionCode: 'DE' });
        if (phoneNumberInstance.valid && phoneNumberInstance.regionCode === 'DE') {
            var number = phoneNumberInstance.number[formatType];
            return withSlash ? number.replace(/\s/g, ' / ') : number;
        }
    }
    catch (_c) {
        return phone;
    }
    return phone;
};
export var generateCookiesSettings = function () { return ({
    id: uuidv4(),
    options: {
        domain: window.location.hostname === 'localhost' ? '' : '.mymoria.de',
        path: '/',
        expires: moment().add(6, 'month').toDate(),
    },
}); };
export var applyCyAttribute = function (cyAttribute, specific) { return ({
    'data-cy': cyAttribute.concat(specific ? "-".concat(specific) : ''),
}); };
export var sleep = function (ms) {
    if (ms === void 0) { ms = 500; }
    return new Promise(function (res) { return setTimeout(function () { return res(null); }, ms); });
};
//# sourceMappingURL=index.js.map